<template>
    <div class=".container-fluid full-height">
        <NavBar></NavBar>

        <div class="d-flex justify-content-center">
               
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 ipannel" style="margin-top:30px;">

                <div class="iscreentitleDiv">
                    <h2 v-if="activeMode == 'new'" class="iscreentitle">Create Client</h2>
                    <h2 v-if="activeMode == 'edit'" class="iscreentitle">Edit Client</h2>
                </div>

                <form  @submit.prevent="submit">
        
                    <div class="form-group required text-left">
                        <label for="vname" class="ilabel">Name</label>
                        <input type="text" class="form-control itextinput" id="vname" v-model="name" required maxlength = "150" :disabled="activeMode == 'view'">
                    </div>
                    <div class="form-group required text-left">
                        <label for="vabbr" class="ilabel">Abbreviation</label>
                        <input type="text" class="form-control itextinput" id="vabbr" v-model="abbreviation" required maxlength = "100" :disabled="activeMode == 'view'">
                    </div>                                
                    <div class="form-group required text-left">
                        <label for="vaddress" class="ilabel">Address</label>
                        <input type="text" class="form-control itextinput" id="vaddress" v-model="address" required maxlength = "400" :disabled="activeMode == 'view'">
                    </div>
                    <div class="form-group required text-left">
                        <label for="vcontact" class="ilabel">Contact Details</label>
                        <input type="text" class="form-control itextinput" id="vcontact" v-model="contact" required maxlength = "400" :disabled="activeMode == 'view'">
                    </div>                  

                    <div class="d-flex justify-content-center " style="padding-top:10px;" v-if="activeMode!='view'">
                        <button type="submit" class="btn btn-primary ibutton mr-3"  :disabled="this.isLoading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                            <font-awesome-icon icon="plus" size="sm"/>
                            {{ getSubmitBtnTxt }}
                        </button>
                    </div>                    

                </form>                

            </div>        
        </div>
        <v-snackbar v-model="showSnackbar" >
            {{ snackBarText }}
            <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
        </v-snackbar>
        <Footer class="footerStickedToBottom" ></Footer> 
    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import Utils from '@/utils/util.js';
import {DB} from '../firebase/db';
import Firebase from 'firebase/app'

export default {   
    name: 'Client',  
    data() {
        return {

            clientID:'',
            name:'',
            abbreviation:'',
            address:'',
            contact:'',            
            createdBy:'',
            createdAt:'',
            modifiedBy:'',
            modifiedAt:'',

            isLoading:false,

            showSnackbar:false,
            snackbarColor:'green',
            snackBarText:'', 
            
            activeMode: 'new',

            originalObject: {
                name:'',
                abbreviation:'',
                address:'',
                contact:'',  
            },
        }
    },
    components: {          
        NavBar,         
        Footer,        
    },
    computed: {
        getSubmitBtnTxt(){
            if(this.activeMode == 'new'){
                return 'Create Client';
            }else if(this.activeMode == 'edit'){
                return 'Save Changes';
            }
            return '';
        }
    },
    created() {
        if(this.mode != undefined){
            this.activeMode = this.mode;
            this.clientID = this.id;
            this.fetchClient(this.clientID);
        }else{
            this.activeMode = 'new';
        }

        this.deriveOriginalObject();
    },
    props:{
        mode:String,
        id:String,
    }, 
    methods: {
        submit(){
            if(this.activeMode == 'new'){
                this.createClient();
            }else if(this.activeMode == 'edit'){
                this.editClient();
            }
        },
        getUser(){
            return this.$store.state.user.name;
        },
        fetchClient(id){
            const _this = this;
            _this.isLoading = true;

            DB.collection("clients").
                where('id', '==', id)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => { 
                        _this.clientID = doc.data().id;
                        _this.name = doc.data().name;
                        _this.abbreviation = doc.data().abbreviation;
                        _this.address = doc.data().address;
                        _this.contact = doc.data().contact;
                        _this.createdBy = doc.data().createdBy;
                        _this.createdAt = doc.data().createdAt;
                        _this.modifiedBy = doc.data().modifiedBy;
                        _this.modifiedAt = doc.data().modifiedAt;
                    });
                    _this.isLoading = false;
                })
                .catch((error) => {
                    _this.showError("Failed to fetch records. Error: ", error);
                    _this.isLoading = false;
                });            
        },
        getClientObject(isNew){

            var data = null;

            if(isNew){
                this.clientID = Utils.getUniqueID();
                data = {
                    id            : this.clientID,
                    name          : this.name,
                    abbreviation  : this.abbreviation,
                    address       : this.address,
                    contact       : this.contact,
                    createdBy     : Utils.getUser(),
                    createdAt     : Firebase.firestore.FieldValue.serverTimestamp(),
                    modifiedBy    : Utils.getUser(),
                    modifiedAt    : Firebase.firestore.FieldValue.serverTimestamp(),
                }
            }else{
                data = {
                    id            : this.clientID,
                    name          : this.name,
                    abbreviation  : this.abbreviation,
                    address       : this.address,
                    contact       : this.contact,
                    createdBy     : this.createdBy,
                    createdAt     : this.createdAt,
                    modifiedBy    : Utils.getUser(),
                    modifiedAt    : Firebase.firestore.FieldValue.serverTimestamp(),
                }
            }
            

            return data;
        },
        async createClient(){            
            

            this.isLoading = true;
            const _this = this;

            DB.collection("clients").
                where('name', '==', this.name).
                get()
                .then((querySnapshot) => {

                    if(querySnapshot.empty){

                        const client = this.getClientObject(true);

                        DB.collection('clients').doc(this.clientID).set(client).then(() => {
                            _this.showMsg("Client created successfully");
                            _this.resetForm();
                             _this.isLoading = false;
                        }).catch(() => {   
                            _this.showError("Failed to create Client");
                            _this.isLoading = false;
                        });
                    }else{
                        _this.showError("Client name already taken");
                        _this.isLoading = false;
                    }
                })
                .catch(() => {
                    _this.showError("Failed to create Client");
                    _this.isLoading = false;
                });   

           
        },      
        async editClient(){  
  
            this.isLoading = true;
            const _this = this;

            DB.collection('clients').doc(this.clientID).update(this.getClientObject(false)).then(() => {
                    _this.isLoading = false;
                    _this.showMsg("Client Updated successfully");
                    _this.deriveOriginalObject();
                }).catch((error) => {   
                    console.log(error);
                    _this.isLoading = false;
                    _this.showError('Failed to update client');
                });
        },
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },          
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        deriveOriginalObject(){
            this.originalObject = {
                name:this.name,
                abbreviation:this.abbreviation,
                address:this.address,
                contact:this.contact,  
            };
        },
        isThereUnsavedChanges(){
            const currentObject = {
                name:this.name,
                abbreviation:this.abbreviation,
                address:this.address,
                contact:this.contact,  
            };
            if(JSON.stringify(this.originalObject) === JSON.stringify(currentObject)){
                return false;
            }else{
                return true;
            }
        }, 
        resetForm(){
            this.name           = '';
            this.abbreviation   = '';
            this.address        = '';
            this.contact        = '';
        },
            
    },
    beforeRouteLeave: function(to, from, next) {
        if(this.isThereUnsavedChanges() == true){
            const answer = window.confirm('You have unsaved changes; are you sure you want to leave this page?')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next();
        }     
    }
    
}


</script>


<style lang="scss">
</style>